import Head from 'next/head';
import Container from 'react-bootstrap/Container'
import HeroSearch from '../../components/HeroSearch'
import {useRouter} from 'next/router'
import TutorSearchContainer from '../../components/tutorSearch/Container'
import jsonApiClient from '../../utils/jsonApiClient'
import {useEffect, useState} from 'react'

export default function TutorsSearch() {
  const router = useRouter()
  const query = router.query
  const { subject, level, lat, lon, address, modality } = query
  const page = parseInt(query.page || 1)

  const movePage = (direction) => {
    router.push({
      query: {
        ...query,
        page: direction === 'next' ? (page + 1) : (page - 1)
      }
    })
  }

  const location = {
    lat,
    lon,
    formattedAddress: address
  }

  const fetcher = ({resource, params}) => {
    const jsonApi = jsonApiClient()
    return jsonApi.findAll(resource, params)
  }

  const [subjectRecord, setSubjectRecord] = useState({})
  const [levelRecord, setLevelRecord] = useState({})

  useEffect(() => {
    if(!subject) return

    const fetchData = async () => {
      const { data } = await fetcher({
        resource: 'subject',
        params: {
          filter: {
            slug: subject
          }
        }
      })
      setSubjectRecord(data[0])
    }
    fetchData()
  }, [subject])

  useEffect(() => {
    if(!level) return

    const fetchData = async () => {
      const { data } = await fetcher({
        resource: 'level',
        params: {
          filter: {
            slug: level
          }
        }
      })
      setLevelRecord(data[0])
    }
    fetchData()
  }, [level])

  return (
    <>
      <Head>
        <title>Search for qualified tutors</title>
      </Head>

      <div className="bg-light bg-gradient py-4 mb-2">
        <Container>
          <HeroSearch compact location={location} modality={modality} subject={subjectRecord} level={levelRecord}/>
        </Container>
      </div>

      <TutorSearchContainer
        subject={subject}
        level={level}
        lat={lat}
        lon={lon}
        modality={modality}
        page={page}
        onPaginate={movePage}
      />
    </>
  )
}
